/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { baseUrl } from '../../services/base'

import Loading from '../../components/Skeleton/loading'

export default function index(data) {
  const [shops, setShops] = useState([])
  const navigateTo = useNavigate()

  const navigate = (e) => {
    localStorage.setItem('shopId', e.target.id)
    navigateTo(`/menu`)
  }

  useEffect(() => {
    setShops(data.data)
  }, [data, shops])

  return (
    <>
      {shops ? shops.map(shop => (
        <div key={shop._id} className='resturantCard' style={shop ? {} : { display : 'none' }}>
          <img src={`${baseUrl.base}${shop ? shop.logoUrl : ''}`} alt='logo' />
          <div className='address'>
            {shop ? shop.address : ''}
          </div>
          <button id={shop._id} className='loginButton' onClick={navigate}>ورود</button>
        </div>
      )) : <Loading />}
    </>
  )
}
